<template>
  <div class="wrap">
    <Head />
    <Nav />

    <router-view />
    <div style="margin: 10px;"></div>
    <Footer />

    <!-- 广告 -->
    <Ad />
  </div>
</template>
<script>
import Head from "@/components/Head";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Ad from "@/components/Ad";

export default {
  name: "Index",
  components: { Head, Nav, Footer, Ad },
  data() {
    return {};
  },
  mounted() {
    window.onscroll = function() {
      if (document.documentElement.scrollTop >= 200) {
        document.querySelector(".head").style = "height: 120px;";
        //document.querySelector('.tools').style = 'top: 70%'
        document.querySelector(".nav").style =
          "top: 120px; background: #014da1;color: #fff";
        //document.querySelector('.navMenu').classList.add('notop')
      } else {
        document.querySelector(".head").style = "";
        //document.querySelector('.tools').style = 'top: 50%'
        document.querySelector(".nav").style = "";
        //document.querySelector('.navMenu').classList.remove('notop')
      }
    };
  }
};
</script>
<style scoped>
.wrap {
  padding-top: 200px;
}

@media screen and (max-width: 768px) {
  .wrap {
    padding-top: 153px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue